import React, { useEffect, useRef } from "react";
import JsBarcode from "jsbarcode";

export function Barcode({ value, height = 48, width = 1.8, className }) {
  const ref = useRef(null);
  useEffect(() => {
    if (ref.current && value) {
      try {
        JsBarcode(ref.current, String(value), {
          format: "CODE128", displayValue: false, height, width, margin: 0, background: "transparent", lineColor: "#000000",
        });
      } catch (e) { /* invalid code */ }
    }
  }, [value, height, width]);
  return <svg ref={ref} className={className} />;
}
